import React from 'react';
import { company } from '../../data/site';
import { useClock } from '../../hooks/useClock';
import { cn } from '../../lib/utils';

// "● Mumbai 14:32 IST": local time at the office, with a live dot
const StatusClock = ({ className }) => {
  const time = useClock(company.timeZone);
  return (
    <span className={cn('label inline-flex items-center gap-2 whitespace-nowrap', className)}>
      <span className="relative flex size-1.5" aria-hidden="true">
        <span className="absolute inline-flex size-full animate-ping-soft rounded-full bg-brand motion-reduce:animate-none" />
        <span className="relative inline-flex size-1.5 rounded-full bg-brand" />
      </span>
      {company.city} <time className="tabular text-foreground">{time}</time> IST
    </span>
  );
};

export default StatusClock;
